import axios from 'axios';
import { createModeratorApiClient } from '../utils/apiClient';

const API_BASE_URL = process.env.REACT_APP_BACKEND_BASE_URL;

/** Public client — no Authorization header (backend does not require auth). */
const publicDataroomClient = axios.create({
  baseURL: API_BASE_URL,
  timeout: 90000,
  headers: { 'Content-Type': 'application/json' },
});

/** Moderator API key — required for /dataroom/articles and /dataroom/dispatch only. */
const authenticatedDataroomClient = createModeratorApiClient();

export const dataroomApi = {
  listArticles: () => authenticatedDataroomClient.get('/dataroom/articles'),

  /**
   * Full text + metadata for dragging a DataRoom article into the chatbot.
   * @param {number} articleId DataRoom row id (not raw_data_id)
   */
  getArticleForChat: (articleId) =>
    authenticatedDataroomClient.get(`/dataroom/articles/${articleId}/for-chat`),

  addArticle: (rawDataId) =>
    authenticatedDataroomClient.post('/dataroom/articles', { raw_data_id: rawDataId }),

  removeArticle: (rawDataId) =>
    authenticatedDataroomClient.delete(`/dataroom/articles/${rawDataId}`),

  clearArticles: () => authenticatedDataroomClient.delete('/dataroom/articles'),

  /**
   * POST /dataroom/generate-email-preview — no API key required.
   */
  generateEmailPreview: (payload) =>
    publicDataroomClient.post('/dataroom/generate-email-preview', payload),

  dispatch: (payload) =>
    authenticatedDataroomClient.post('/dataroom/dispatch', payload),

  getHistory: (historyId) =>
    authenticatedDataroomClient.get(`/dataroom/history/${historyId}`),

  patchSettings: (payload) =>
    authenticatedDataroomClient.patch('/dataroom/settings', payload),
};
